import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 px-3 py-4 sm:items-center sm:px-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex w-full items-end justify-end px-1 pb-3 sm:px-6 sm:py-4"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col w-full h-full items-center justify-around"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-semibold" }, "Finalizando", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "animate-loading-spin w-20"
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 3,
  class: "w-full"
}
const _hoisted_9 = { class: "flex flex-col items-center text-center" }
const _hoisted_10 = { class: "mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-red-50 text-red-600" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-slate-950" }, "Não foi possível finalizar", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 max-w-sm text-sm leading-6 text-slate-500" }, " Houve um problema ao processar seu pagamento. Revise os dados informados ou tente novamente em instantes. ", -1)
const _hoisted_13 = { class: "mt-6 w-full rounded-2xl border border-red-100 bg-red-50 p-4 text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold uppercase tracking-[0.18em] text-red-400" }, "Detalhes do erro", -1)
const _hoisted_15 = { class: "mt-2 max-h-32 overflow-y-auto break-words text-sm leading-6 text-red-700" }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "flex flex-col items-center justify-center xs:w-72 md:w-96" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-2xl mb-10 text-center" }, " Compra realizada com sucesso! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ModalPix = _resolveComponent("ModalPix")!

  return (_ctx.show != 'waiting')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-full rounded-3xl bg-white px-4 py-4 shadow-2xl sm:px-6 sm:py-5", _ctx.show == 'pix' ? 'max-w-5xl' : 'max-w-[30rem]'])
        }, [
          (_ctx.show != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, [
                  _createVNode(_component_Icon, {
                    icon: "teenyicons:x-solid",
                    class: "text-cinza-padrao hover:cursor-pointer"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'pix')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ModalPix, {
                  regenerate: _ctx.regenerate,
                  restartingQR: _ctx.restartingQR
                }, null, 8, ["regenerate", "restartingQR"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Icon, {
                      icon: "solar:danger-triangle-bold",
                      class: "text-5xl"
                    })
                  ]),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.errorMessage ?? 'Sem detalhes disponíveis.'), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "mt-6 h-12 w-full rounded-2xl bg-slate-950 text-sm font-bold text-white transition hover:bg-slate-800",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                  }, " Voltar para o checkout ")
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.show == 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Icon, {
                    icon: "lets-icons:check-fill",
                    class: "text-9xl text-green-600 mb-10"
                  }),
                  _hoisted_18
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}